<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <!--
                <v-card-title>
                    <h2>{{ $t("myAccount") }}</h2>
                </v-card-title>
                -->

                <v-card-text>{{ $t("supportHint") }}</v-card-text>

                <v-text-field
                    v-model="subject"
                    :label="`${$t('subject')} *`"
                    class="mx-3"
                    required
                ></v-text-field>

                <v-card-text class="v-scrollable">
                    <v-textarea
                        v-model="messageText"
                        rows="10"
                        :label="$t('descriptionStepsToReproduce')"
                    ></v-textarea>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="clearDataClick">{{ $t("clear") }}</v-btn>
                    <v-btn color="success" @click="sendDataClick">{{ $t("send") }}</v-btn>
                </v-card-actions>
            </v-card>
            <message-box ref="MessageBox"/>
            <message-dialog ref="MessageDialog"/>
            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox    from "@/components/dialogs/MessageBox";
    import MessageDialog from "@/components/dialogs/MessageDialog";

    export default {
        name: "SupportForm",

        components: {
            MessageBox,
            MessageDialog
        },

        data () {
            return {
                alert: "",
                alertType: "success",
                progressBarVisible: false,
                breadCrumbs: [
                    { text: "Техническая поддержка", disabled: false },
                ],
                subject: "",
                messageText: "",
                dialogWatcher: null,
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },
        },

        async mounted () {
            this.applyLocale();
            // TODO recapctha, на данный момент не работает
            // await this.$recaptchaLoaded();
            // const recaptcha = this.$recaptchaInstance;
            // recaptcha.hideBadge();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("support"), disabled: false }
                ];
            },

            /**
             * Очистка формы
             */
            clearData () {
                this.subject     = "";
                this.messageText = "";
            },

            /**
             * Обработчик нажатия кнопки очистки формы
             */
            clearDataClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.$refs.MessageDialog.answer      = null;
                this.$refs.MessageDialog.title       = this.$t("clearTheForm");
                this.$refs.MessageDialog.messageText = this.$t("clearFormRequest");

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.dialog",
                    () => {
                        if (this.$refs.MessageDialog.answer) {
                            this.clearData();
                        }
                    }
                );

                this.$refs.MessageDialog.dialog = true;
            },

            /**
             * Обработчик нажатия кнопки сохранения данных
             */
            async sendDataClick () {
                // this.recaptchaToken = await this.$recaptcha("login"); //this.$recaptcha("register");

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}support/`,
                    data: {
                        subject:     this.subject,
                        messageText: this.messageText,
                        // token:       this.recaptchaToken
                    },
                    withCredentials: true
                }).then(response => {
                    let r_data = response.data;

                    if (r_data.status == "success") {
                        this.alertType = "success";
                        this.alert     = this.$t("messageSent");
                        this.clearData();
                    } else {
                        /**
                         * Ответы
                         * ======
                         * Статус failure:
                         *   captcha_api_call_failed
                         *   captcha_check_negative
                         *   company_already_registered
                         *   company_name_is_empty
                         *   email_is_empty
                         *   password_is_empty
                         *   user_already_exists
                         *
                         */
                        switch (r_data.result) {
                            case "captcha_api_call_failed":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                                break;
                            case "captcha_check_negative":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                                break;
                            case "company_already_registered":
                                this.showMessageBox(this.$t("attention"), this.$t("companyAlreadyRegistered"));
                                break;
                            case "email_address_rejected":
                                this.showMessageBox(this.$t("attention"), this.$t("emailAddressRejected"));
                                break;
                            case "send_mail_error":
                                this.showMessageBox(this.$t("attention"), this.$t("sendMailError"));
                                break;
                            default:
                                this.showMessageBox(this.$t("error"), this.$t("cantSendMessage"));
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {
                                window.location.reload();
                            }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSendMessage") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSendMessage"));
                    }
                });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
</style>
